import { render, staticRenderFns } from "./RemindPassword.vue?vue&type=template&id=4c7c79c0&scoped=true&"
import script from "./RemindPassword.vue?vue&type=script&lang=js&"
export * from "./RemindPassword.vue?vue&type=script&lang=js&"
import style0 from "./RemindPassword.vue?vue&type=style&index=0&id=4c7c79c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c79c0",
  null
  
)

component.options.__file = "RemindPassword.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {VTextField})
